<!-- Hero Section -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h1 class="healthcare-heading mb-3">
                        End-to-End E-commerce Website Development Services that Drive Revenue and Scale with Your Growth
                    </h1>
                    <p class="healthcare-subheading2 mb-4">
                        Unlock seamless digital commerce experiences with custom e-commerce software development
                        tailored to accelerate sales, enhance customer journeys, and scale your business with
                        confidence.
                    </p>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="scheduleDemo()">
                            Schedule a Free Consultation
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <video #heroVideo preload="auto"
                        src="../../../../assets/industries/ecommerce/ecommerce-herovideo.webm"
                        class="img-fluid hero-image" autoplay loop muted playsinline disablePictureInPicture>
                    </video>
                </div>
            </div>
        </div>
    </section>
</div>
<!-- Software Solutions in Healthcare Section -->
<section class="solutions-section">
    <div class="container">
        <div class="section-header text-center mx-auto">
            <h2>Why E-commerce Needs Scalable Software Solutions</h2>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="solutions-image-container">
                    <div class="solution-image-card image-one">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/ecommerce/ecommerce-img1.png"
                            alt="Team collaborating on computer">
                    </div>
                    <div class="solution-image-card image-two">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/ecommerce/ecommerce-img2.png"
                            alt="Two colleagues looking at a laptop">
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="solutions-content">
                    <p>
                        The e-commerce industry is evolving faster than ever, but businesses still face challenges like
                        fragmented systems that increase operational costs, poor user experience leading to high cart
                        abandonment rates, limited scalability causing site crashes during peak traffic periods, slow
                        backend processes, and rising customer expectations.
                    </p>
                    <p>
                        Kalpita Technologies helps brands overcome these complexities with custom e-commerce software
                        development that streamlines operations, boosts performance, and delivers secure,
                        high-converting shopping experiences.
                    </p>
                    <p><strong>Key benefits of adopting modern E-commerce software solutions</strong></p>
                    <div class="features-list">
                        <ul>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Reduce order
                                processing time by up to 50% with automated inventory and fulfillment workflows</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Increase conversion
                                rates by 25-40% through personalized, AI-driven customer experiences</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Handle 10x traffic
                                spikes seamlessly with auto-scaling cloud architecture</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Secure payment
                                processing and compliance-ready platforms</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Faster go-to-market
                                with automated workflows & integrated systems</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Our Solutions & Impact Section -->
<section class="impact-section" #impactSection>
    <div class="container">
        <div class="text-center">
            <h2 class="impact-heading">Kalpita Technologies’ E-Commerce Solutions</h2>
        </div>
        <div class="row align-items-center impact-main-content">
            <!-- Added Animation Trigger -->
            <div class="col-lg-6" [@fadeInUpStagger]="impactSectionVisible ? 'visible' : 'hidden'">
                <!-- Added animate-item class -->
                <p class="impact-description animate-item">
                    We deliver comprehensive e-commerce development services, from platform design to backend
                    engineering, mobile commerce apps, payment gateway integration, marketplace development, analytics,
                    and cloud deployment. Our approach to solution architecture and design experiences feature the
                    following:
                </p>
                <!-- Added animate-item class -->
                <ul class="simple-impact-list animate-item">
                    <li>
                        <strong>Headless Commerce Architecture:</strong> Decouple frontend and backend for
                        faster updates and omnichannel experiences
                    </li>
                    <li>
                        <strong>Progressive Web Apps (PWA):</strong> App-like experiences without app store
                        dependencies.
                    </li>
                    <li>
                        <strong>AI-Powered Personalization:</strong> Real-time product recommendations and
                        dynamic pricing
                    </li>
                </ul>
                <p class="impact-description animate-item">
                    Whether you need B2B e-commerce platform development or guidance on how to build a custom e-commerce
                    platform, we craft solutions that are scalable, secure, and optimized for conversions. We leverage
                    AI-powered development tools to deliver your e-commerce platform faster and more efficiently:
                </p>
                <ul class="simple-impact-list animate-item">
                    <li>
                        <strong>40-60% faster development cycles</strong> through AI code generation and automation
                    </li>
                    <li>
                        <strong>Intelligent testing</strong> that identifies bugs and edge cases human testers might
                        miss
                    </li>
                    <li>
                        <strong>Predictive analytics integration</strong> built into every platform for data-driven
                        decision making
                    </li>
                    <li>
                        <strong>Conversational commerce</strong> capabilities including AI chatbots and virtual shopping
                        assistants
                    </li>
                    <li>
                        <strong>Visual search and recommendation engines</strong> that increase discovery and
                        conversions
                    </li>
                </ul>
            </div>
            <div class="col-lg-6">
                <!-- Added Shine Effect -->
                <div class="impact-image-wrapper">
                    <img src="../../../../assets/industries/ecommerce/ecommerce-solutions-img.png"
                        alt="Developer working on multiple screens">
                    <div class="shine"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Case Studies Section -->
<section class="case-studies-section">
    <div class="container">

        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-8">
                <h2 class="section-heading">E-commerce Success Stories</h2>
                <!-- <p class="section-subheading">Real-world examples of our healthcare solutions in action.</p> -->
            </div>
        </div>

        <!-- Slider Wrapper -->
        <div class="case-study-slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

            <!-- The Sliding Track -->
            <div class="slider-viewport">
                <div class="slider-track" [style.transform]="'translateX(-' + (currentSlide * 100) + '%)'">

                    <!-- Loop through Case Studies -->
                    <div class="case-study-slide" *ngFor="let study of caseStudies">
                        <div class="row align-items-center">

                            <!-- Image Column (Left) -->
                            <div class="col-lg-5 d-flex justify-content-center">
                                <div class="case-study-image-wrapper">
                                    <img [src]="study.image" [alt]="study.title" class="img-fluid">
                                </div>
                            </div>

                            <!-- Content Column (Right) -->
                            <div class="col-lg-7">
                                <div class="case-study-content">
                                    <h3 class="case-study-title">{{ study.title }}</h3>
                                    <p class="case-study-description">
                                        {{ study.description }}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- End Loop -->

                </div>
            </div>

            <!-- Pagination Dots -->
            <div class="slider-dots">
                <span *ngFor="let study of caseStudies; let i = index" class="dot" [class.active]="i === currentSlide"
                    (click)="goToSlide(i)">
                </span>
            </div>

        </div>
    </div>
</section>
<!-- Testimonial Section -->
<!-- <section class="written-testimonial-section custom-testimonial written-testimonial-wrapper">
  <h2 class="written-heading">Testimonials</h2>

  <app-clients-testimonal [hideHeading]="true"></app-clients-testimonal>
</section> -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h2 class="healthcare-heading mb-3">
                        Client Testimonials
                    </h2>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="testimonials()">
                            Check out our clients’ stories
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <img src="../../../../assets/clientscta/clientsctaimage.webp" alt="Clients CTA"
                        class="img-fluid testimonial-hero-image">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- FAQ -->
<app-faq [faqList]="EcommerceFaqs"></app-faq>
<!-- Final CTA -->
<div class="final-cta-bg">
    <img src="../../../../assets/industries/healthcare/half-tablet.png" alt="Decorative capsule"
        class="cta-capsule-img">
    <section id="final-cta" class="final-cta-section container">
        <div class="section-header text-center mx-auto">
            <!-- <h2>Final CTA</h2> -->
        </div>
        <div class="row align-items-center">
            <div class="col-lg-6 cta-content-col">
                <h2 class="cta-heading-small">Ready to Build a High-Performing E-commerce Platform?</h2>
                <div class="mb-5 cta-btn-group">
                    <!-- <button class="btn btn-get-started me-3" (click)="getStarted()">
            Get Started
          </button> -->
                    <button class="btn btn-schedule-demo" (click)="scheduleDemo()">
                        Schedule a Free Consultation
                    </button>
                </div>
            </div>
            <div class="col-lg-6 text-center">
                <img src="../../../../assets/industries/healthcare/health-pod-clinic.png" alt="Health POD Clinic"
                    class="img-fluid cta-clinic-image">
            </div>
        </div>
    </section>
</div>
<!-- Explore More Industries -->
<app-explore-more-industries></app-explore-more-industries>